import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  BtNoticiaNovidades,
  ColunaRegras,
  GlobalStyle,
  TitNoticias,
  Clear,
  DivBtsNoticiaNovidades,
  DivAcordeon2,
} from "./Estilos";
import InfiniteCalendar, {
  Calendar,
  defaultMultipleDateInterpolation,
  withMultipleDates,
} from "react-infinite-calendar";
import "react-infinite-calendar/styles.css";
import { URLBunge } from "./Componentes/Config";
import MenuPrinc from "./Componentes/MenuPrinc";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import "date-fns/locale/pt";

export default function AcademiaFormularioCalendario(props) {
  const history = useHistory();
  const [Loading, setLoading] = useState(true);
  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [dataMesAno, setDataMesAno] = useState();
  const [listaDias2, setListaDias2] = useState([]);
  const [Token, setToken] = useState(localStorage.getItem("c_token"));

  function isDisabled(day) {
    if (day !== listaDias2) {
      return true;
    }
  }

  function CarregaCalendario(dia, mes, ano) {
    if (mes == undefined && ano == undefined) {
      const DiaHoje = new Date();
      mes = DiaHoje.toISOString().substr(5, 2);
      ano = DiaHoje.toISOString().substr(0, 4);
    }
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/ListaCalendarioSite/`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        for (let i = 0; i < result.calendario.length; i = i + 1) {
          dia = result.calendario[i].data.substr(0, 2);
          mes = result.calendario[i].data.substr(3, 2) - 1;
          ano = result.calendario[i].data.substr(6, 4);
          setListaDias2((listaDias2) => [
            ...listaDias2,
            new Date(ano, mes, dia),
          ]);
        }
        setDataMesAno(mes + " - " + ano);
        setLoading(false)
      })
      .catch((error) => console.log("error", error));
  }

  function SelecionaDia(day) {
    const filtrada = listaDias2.filter((a) => {
      return day.toISOString().substr(0, 10) === a.toISOString().substr(0, 10);
    });
    if (filtrada.length > 0) {
      var dia = day.toISOString().substr(8, 2);
      var mes = day.toISOString().substr(5, 2);
      var ano = day.toISOString().substr(0, 4);
      props.history.push("/AcademiaFormularioRequisicoes", {
        dia: dia,
        mes: mes,
        ano: ano,
      });
    }
  }

  useEffect((props) => {
    CarregaCalendario();
  }, []);

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}
      <GlobalStyle />
      <ColunaRegras>
        <div className={"AreaColunaRegras"}>
          <TitNoticias>Requisições de Atendimento</TitNoticias>
          <Clear />
          <DivBtsNoticiaNovidades>
            <BtNoticiaNovidades
              onClick={() => {
                props.history.push("/AcademiaFormularioAtendimento");
              }}
              variant="contained"
            >
              NOVO ATENDIMENTO
            </BtNoticiaNovidades>
            <BtNoticiaNovidades
              onClick={() => {
                props.history.push("/AcademiaFormularioListaTecnico");
              }}
              variant="contained"
            >
              VISÃO TÉCNICO
            </BtNoticiaNovidades>
          </DivBtsNoticiaNovidades>
          <Clear />
          <DivAcordeon2>
            <InfiniteCalendar
              height={450}
              displayOptions={{
                shouldHeaderAnimate: true,
                showTodayHelper: false,
                showHeader: false,
              }}
              Component={withMultipleDates(Calendar)}
              interpolateSelection={defaultMultipleDateInterpolation}
              selected={listaDias2}
              onSelect={(day) => SelecionaDia(day)}
              locale={{
                locale: require("date-fns/locale/pt"),
                headerFormat: "MMMM",
                weekdays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
              }}
            />
          </DivAcordeon2>
        </div>
      </ColunaRegras>
      <MenuPrinc Pagina="Pesquisas" />
    </>
  );
}
